const RouteLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="w-6 h-6 border-2 border-neutral-400 border-t-red-600 rounded-full animate-spin"></div>
    </div>
  );
};

export default RouteLoader;
